module.exports = __webpack_public_path__ + "static/media/suite.5de1f95e.png";